import React, { useEffect, useState } from "react";
import { Table, Tag, Button, Row, Tooltip, Modal, Descriptions, Input, notification } from "antd";
import { useLoading } from "../../context/loadingContext";
import dayjs from "dayjs";
import SearchDatePicker from "../../components/search/datePicker";
import { FilterOutlined, RedoOutlined, RollbackOutlined } from "@ant-design/icons";
import { useAdmin } from "../../context/adminContext";
import moneyFormat from "../../functions/utils/moneyFormat";
import GetBankTransactionLog from "functions/admin/getBankTransactionLog";
import { post } from "../../service/api";
import { useParams } from "react-router-dom";
import SearchAdmin from "components/search/searchAdmin";
import { bg_button, bg_shadow } from "constant/css";
import TablePagination from "components/pagination/tablePagination";

const BankTransactionLog = () => {
  const { account } = useParams();

  const { showLoading, hideLoading } = useLoading();
  const { searchFields, setSearchFields, showFilter, setShowFilter } =
    useAdmin();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [paginationData, setPaginationData] = useState({});
  const [refundModal, setRefundModal] = useState({ open: false, record: null });
  const [refundFromAccount, setRefundFromAccount] = useState("5570025382");
  const [refundTransferId, setRefundTransferId] = useState("");

  const getNextTransferId = () => {
    const today = dayjs().format("YYYY-MM-DD");
    const saved = JSON.parse(localStorage.getItem("refund_transferid") || "{}");
    if (saved.date === today) {
      return String(saved.id).padStart(4, "0");
    }
    return "0190";
  };

  const saveAndIncrementTransferId = (currentId) => {
    const today = dayjs().format("YYYY-MM-DD");
    localStorage.setItem(
      "refund_transferid",
      JSON.stringify({ date: today, id: parseInt(currentId, 10) + 1 })
    );
  };
  useEffect(() => {
    prepareQueryStringAndSearch();
  }, [page, pageSize]);

  useEffect(() => {
    if (page === 1) prepareQueryStringAndSearch();
    else setPage(1);
  }, [searchFields, account]);
  const prepareQueryStringAndSearch = () => {
    //object fields length

    const searchFieldsLength = Object.keys(searchFields).length;
    var queryString = ``;
    if (searchFieldsLength !== 0) {
      queryString = Object.keys(searchFields)
        .map((key) => {
          if (!searchFields[key]) return;
          if (key.includes("At") || key.includes("Date")) {
            // it is date
            return `${key}=${searchFields[key]
              .map((e, i) => {
                if (i == 0)
                  return dayjs(e).startOf("day").format("YYYY-MM-DD HH:MM");
                return dayjs(e).endOf("day").format("YYYY-MM-DD HH:MM");
              })
              .join("->")}`;
          }
          return `${key}=${encodeURIComponent(searchFields[key])}`;
        })
        .join("&");
      fetchTransactionLogs(queryString, page, pageSize);
    } else fetchTransactionLogs("", page, pageSize);
  };
  const defaultColumns = [
    {
      title: (
        <SearchAdmin
          sort={false}
          title="ID"
          fieldName="id"
          width={120}
          debounceMs={1500}
          placeholder="ID..."
        />
      ),
      dataIndex: "id",
      key: "id",
      fixed: "left",
      width: 120,
    },
    {
      title: <span className="text-xs">Данс</span>,
      dataIndex: "accountNumber",
      key: "accountNumber",
      width: 120,
    },
    {
      title: <span className="text-xs">Хүлээн авагч/ шилжүүлэгч</span>,
      dataIndex: "relatedAccount",
      key: "relatedAccount",
      width: 140,
    },
    {
      title: (
        <SearchAdmin
          sort={false}
          title="Гүйлгээний утга"
          fieldName="description"
          width={300}
          debounceMs={1500}
          placeholder="Утга хайх..."
        />
      ),
      dataIndex: "description",
      key: "description",
      width: 300,
      render: (e, row) => {
        const text = String(e).substring(0, 47);
        const isHighlighted =
          !String(text).toLowerCase().includes("xpay") &&
          !String(text).toLowerCase().includes("qpay") &&
          !String(text).toLowerCase().includes("merchant") &&
          !String(text).toLowerCase().includes("negdi");

        return (
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <Tooltip title={e}>
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "100%",
                }}
              >
                {isHighlighted ? (
                  <Tag color="error" className="text-xs">
                    {text}
                  </Tag>
                ) : (
                  <span className="text-xs">{text}</span>
                )}
              </div>
            </Tooltip>
            {isHighlighted && (
              <Button
                size="small"
                danger
                icon={<RollbackOutlined />}
                onClick={() => {
                  setRefundFromAccount("5570025382");
                  setRefundTransferId(getNextTransferId());
                  setRefundModal({ open: true, record: row });
                }}
              />
            )}
          </div>
        );
      },
    },
    {
      title: <span className="text-xs">Дүн</span>,
      dataIndex: "amount",
      key: "amount",
      align: "right",
      render: (e) => (
        <Tag color={e > 0 ? "cyan" : "warning"}>
          {moneyFormat(parseFloat(e))}
        </Tag>
      ),
      width: 120,
    },
    {
      title: <span className="text-xs">Үлдэгдэл</span>,
      dataIndex: "remain",
      key: "remain",
      align: "right",
      render: (e) => moneyFormat(parseFloat(e)),
      width: 130,
    },
    {
      title: (
        <SearchDatePicker
          title="Гүйлгээний огноо"
          datePicker
          fieldName="trnDate"
          width={260}
        />
      ),
      dataIndex: "trnDate",
      key: "trnDate",
      width: 270,
      render: (e) => (e ? dayjs(e).format("YYYY-MM-DD") : "-"),
    },
    {
      title: "Татсан огноо",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      render: (e) => (e ? dayjs(e).format("YYYY-MM-DD HH:mm") : "-"),
    },
  ];
  useEffect(() => {
    refresh();
  }, []);
  const fetchTransactionLogs = async (queryString, page, size) => {
    showLoading();
    const response = await GetBankTransactionLog(
      `&accountNumber=${account}&page=${page}&size=${size}&${queryString}`
    );
    hideLoading();
    if (response) {
      setData(response.data);
      setPaginationData(response.pagination);
    }
  };
  const changePage = (page) => {
    setPage(page);
  };
  const changeSize = (current, size) => {
    setPageSize(size);
  };
  const refresh = () => {
    setPage(1);
    setSearchFields({});
    fetchTransactionLogs("", 1, pageSize);
  };
  const toggleFilter = () => {
    setShowFilter(!showFilter);
  };

  const handleRefundSubmit = async () => {
    const rec = refundModal.record;
    showLoading();
    try {
      // 2. Bearer token → шилжүүлэг
      // const payload = {
      //   fromAccount: refundFromAccount,
      //   toAccount: rec.relatedAccount,
      //   toCurrency: "MNT",
      //   amount: Math.abs(parseFloat(rec.amount)),
      //   description: "Aldaatai hiisen guilgee tul butsaav eSukh.mn",
      //   currency: "MNT",
      //   loginName: "contact@smartbilling.mn",
      //   tranPassword: "@BillinG!@#321",
      //   transferid: refundTransferId,
      //   URL: "domestic",
      // };
      const payload = {
        fromAccount: refundFromAccount,
        toAccount: rec.relatedAccount,
        amount: Math.abs(parseFloat(rec.amount)),
        refundTransferId: refundTransferId,
      }

      await post("/admin/transfer/domestic", payload);

      saveAndIncrementTransferId(refundTransferId);
      setRefundModal({ open: false, record: null });
      notification.success({ message: "Гүйлгээ амжилттай буцаагдлаа" });
    } catch (err) {
      notification.error({
        message: err.response?.data?.message || err.message || "Алдаа гарлаа",
      });
    } finally {
      hideLoading();
    }
  };

  return (
    <div className="vatMerchantListontainer mt-3">
      <Row style={{ gap: 10 }}>
        <div className="addButtonMerchant">
          <Button
            type="primary"
            className={`${bg_button} rounded-xl ${bg_shadow}`}
            onClick={refresh}
          >
            <RedoOutlined />
          </Button>
        </div>
        <div className="addButtonMerchant">
          <Button
            type={"primary"}
            className={`spayDefaultButton ${bg_button} rounded-xl ${bg_shadow} ${!showFilter && "spayDefaultButtonInactive"
              }`}
            onClick={toggleFilter}
          >
            <FilterOutlined />
          </Button>
        </div>
      </Row>
      <div className="tableContainer">
        <Table
          columns={defaultColumns}
          rowKey={(record) => record.id}
          scroll={{
            x: "max-content",
            y: "calc(100vh - 38vh)",
          }}
          size="small"
          pagination={false}
          dataSource={data}
        // summary={(pageData) => {
        //   return (
        //     <Table.Summary fixed>
        //       <Table.Summary.Row className="summaryRow">
        //         <Table.Summary.Cell index={0} colSpan={2} align="right">
        //           Нийт дүн:
        //         </Table.Summary.Cell>
        //         <Table.Summary.Cell index={1} colSpan={2} align="right">
        //           {summary ? moneyFormat(summary.totalAmount) : 0}
        //         </Table.Summary.Cell>
        //       </Table.Summary.Row>
        //     </Table.Summary>
        //   );
        // }}
        ></Table>
        <TablePagination
          paginationData={paginationData}
          page={page}
          changePage={changePage}
          changeSize={changeSize}
        />
      </div>
      <Modal
        title="Гүйлгээ буцаах"
        open={refundModal.open}
        onCancel={() => setRefundModal({ open: false, record: null })}
        footer={
          <Button danger type="primary" onClick={handleRefundSubmit}>
            Буцаах
          </Button>
        }
        width={560}
      >
        {refundModal.record && (() => {
          const rec = refundModal.record;
          const amount = Math.abs(parseFloat(rec.amount));
          return (
            <Descriptions bordered column={1} size="small">
              <Descriptions.Item label="fromAccount">
                <Input
                  value={refundFromAccount}
                  onChange={(e) => setRefundFromAccount(e.target.value)}
                  size="small"
                />
              </Descriptions.Item>
              <Descriptions.Item label="toAccount">{rec.relatedAccount}</Descriptions.Item>
              <Descriptions.Item label="toCurrency">MNT</Descriptions.Item>
              <Descriptions.Item label="amount">{amount}</Descriptions.Item>
              <Descriptions.Item label="description">Aldaatai hiisen guilgee tul butsaav eSukh.mn</Descriptions.Item>
              <Descriptions.Item label="currency">MNT</Descriptions.Item>
              <Descriptions.Item label="loginName">contact@smartbilling.mn</Descriptions.Item>
              <Descriptions.Item label="tranPassword">@BillinG!@#321</Descriptions.Item>
              <Descriptions.Item label="transferid">
                <Input
                  value={refundTransferId}
                  onChange={(e) => setRefundTransferId(e.target.value)}
                  size="small"
                />
              </Descriptions.Item>
              <Descriptions.Item label="URL">domestic</Descriptions.Item>
            </Descriptions>
          );
        })()}
      </Modal>
    </div>
  );
};

export default BankTransactionLog;
